import { ApplicationState } from './redux'
let pathToApi

if (process.env.REACT_APP_APPENV === 'production') {
  pathToApi = 'https://mentoringapiindra.auren.es'
} else {
  pathToApi = 'https://mentoringapiindra.auren.es' //'http://localhost:8000'
}

export const apiPath = pathToApi + '/v1'

export const api = pathToApi

export const get = (url) =>
  fetch(api + url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: getToken(),
    },
  })

export const post = (url, body) =>
  fetch(api + url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: getToken(),
    },
    body: JSON.stringify(body),
  })

export const postFile = (url, body) =>
  fetch(api + url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      Authorization: getToken(),
    },
    body: body,
  })

const getToken = (): string => {
  try {
    const s = localStorage.getItem('state')
    if (s) {
      const state: ApplicationState = JSON.parse(s)
      return state.auth.token || ''
    }
    return ''
  } catch (e) {
    console.error(`Couldn't get token from localStorage ` + e.message)
    return ''
  }
}

export const credentialsCookie = {
  expirationInDays: 1,
  name: 'credentials',
}

export const persistedStateSlices = ['settings']

export const stateSyncBuffer = 500

export const cacheValidAfter = 1537438229850



// WEBPACK FOOTER //
// ./src/config.ts